import React, { useState, useEffect } from "react";

const MobileBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isDismissed = sessionStorage.getItem("hideMobileBanner");
    const isMobile = window.innerWidth < 768; // adjust breakpoint if needed
    if (!isDismissed && isMobile) {
      setVisible(true);
    }
  }, []);

  const dismissBanner = () => {
    sessionStorage.setItem("hideMobileBanner", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="bg-warning text-dark p-2 text-center position-relative fw-bold">
      <span>Not optimized for mobile yet — try on desktop.</span>
      <button
        onClick={dismissBanner}
        className="btn-close position-absolute end-0 top-0 m-2"
        aria-label="Close"
      ></button>
    </div>
  );
};

export default MobileBanner;